import Vue from 'vue'
import axios from 'axios'

const token = document.head.querySelector('meta[name="csrf-token"]')
if (!token) {
  //throw new Error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

const baseUrl = document.head.querySelector('base')
if (!baseUrl) {
  //throw new Error('Base url not found')
}

const axiosOptions = {
  baseURL: baseUrl ? baseUrl.href : '/',
  headers: {
    common: {
      Accept: 'application/json, text/plain, */*',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': token ? token.content : '',
    },
  },
}

const Request = axios.create(axiosOptions)
Vue.prototype.$axios = Request

export default Request
